<template>
  <vx-card>
    <vs-row>
      <vs-col>
          <vs-row>
          <vs-col class="vx-col w-full sm:w-1/2 mb-2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <div class="vx-col sm:w-1/2 md:w-full w-full mb-2">
            <label class="text-sm opacity-75">Time zone:</label>
            <v-select
              :options="timezoneOptions"
              :reduce="item => item.text" label="text"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-validate="'required'"
              class="w-full"
              name="timezoneFilter"
              v-model="timezoneFilter"
              :value='timezoneFilter'
            />
          </div>
          </vs-col>
          <vs-col  class="mb-4 pa-4 mg-30" vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
              <a href="#" @click= "saveTimeZone()">
                <u>Save</u>
              </a>
          </vs-col>
          </vs-row>
          <vs-row v-if="IsAdmin">
            <vs-col class="vx-col w-full sm:w-1/2 mb-2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <div class="vx-col w-full">
                <label class="text-sm opacity-75">Select Industry</label>
                <v-select
                  :options="industryList"
                  :clearable="false"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="industryFilter"
                  :value="industryFilter"
                  class="mb-4 md:mb-3"
                />
              </div>
            </vs-col>
            <vs-col  class="mb-4 mg-30" vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
              <a href="#" @click= "industryFilter='', industryPopup=true">
                <u>Add</u>
              </a>
            </vs-col>
            <vs-col  class="mb-4 mg-30" vs-type="flex" vs-justify="center" vs-align="center" vs-w="0.5">
              <a href="#" @click= "setValues('Industry', industryFilter), industryPopup=true">
                <u>Edit</u>
              </a>
            </vs-col>
          </vs-row>
          <vs-row v-if="IsAdmin">
            <vs-col class="vx-col w-full sm:w-1/2 mb-2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
              <div class="vx-col w-full">
                <label class="text-sm opacity-75">Select Reference</label>
                <v-select
                  :options="referenceList"
                  :clearable="false"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="referenceFilter"
                  :value='referenceFilter'
                  class="mb-4 md:mb-3"
                />
              </div>
            </vs-col>
            <vs-col class="vs-col mb-2 mg-30" vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
              <a href="#" @click="referenceFilter='', referencePopup=true">
                <u>Add</u>
              </a>
            </vs-col>
            <vs-col class="vs-col mb-2 mg-30" vs-type="flex" vs-justify="center" vs-align="center" vs-w="0.5">
              <a href="#" @click="setValues('Reference', referenceFilter), referencePopup=true">
                <u>Edit</u>
              </a>
            </vs-col>
          </vs-row>
      </vs-col>
    </vs-row> 
    <!-- popup -->
    <div class="demo-alignment">
      <vs-popup classContent="popup-example" title="Add Industry" :active.sync="industryPopup">
        <vs-row class="vx-row">
          <vs-col
            vs-offset="4"
            vs-justify="center"
            vs-align="center"
            class="vx-col w-full"
          >
            <vs-input
              class="mb-3 sm:mb-3"
              name="industryFilter"
              label-placeholder="Industry"
              v-model="industryFilter"
              v-validate="'required'"
              :value="industryFilter"
            />
            <span
              class="text-danger text-sm w-full"
              v-show="errors.has('industryFilter')"
            >{{industryErrorMessage}}</span>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col
            vs-offset="4"
            vs-type="flex"
            vs-justify="center"
            class="mb-4 md:mb-3"
            vs-align="center"
            vs-w="4"
          >
            <vs-button
              vs-offset="6"
              vs-type="flex"
              vs-justify="center"
              @click="saveSettings('Industry',industryFilter)"
              class="mr-2 mb-3"
            >Save</vs-button>
            <vs-button
              vs-offset="4"
              vs-type="flex"
              vs-justify="center"
              color="warning"
              type="border"
              class="mr-2 mb-3"
              @click="industryPopup=false; resetSetting()"
            >Cancel</vs-button>
          </vs-col>
        </vs-row>
      </vs-popup>
    </div>
    <div class="demo-alignment">
      <vs-popup classContent="popup-example" title="Add Reference" :active.sync="referencePopup">
        <vs-row  class="vx-row">
          <vs-col
            vs-offset="4"
            vs-justify="center"
            vs-align="center"
            class="vx-col w-full mb-2"
            >
            <vs-input
              class="mb-3 sm:mb-3"
              label-placeholder="Reference"
              v-model="referenceFilter"
              v-validate="'required'"
              name="referenceFilter"
              :value='referenceFilter'
            />
            <span
              class="text-danger text-sm w-full"
              v-show="errors.has('referenceFilter')"
            >{{referenceErrorMessage}}.</span>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col
            vs-offset="4"
            vs-type="flex"
            vs-justify="center"
            class="mb-4 md:mb-3"
            vs-align="center"
            vs-w="4"
          >
            <vs-button
              vs-offset="6"
              vs-type="flex"
              vs-justify="center"
              @click="saveSettings('Reference',referenceFilter)"
              class="mr-2 mb-3"
            >Save</vs-button>
            <vs-button
              vs-offset="4"
              vs-type="flex"
              vs-justify="center"
              color="warning"
              type="border"
              class="mr-2 mb-3"
              @click="referencePopup=false; resetSetting()"
            >Cancel</vs-button>
          </vs-col>
        </vs-row>
      </vs-popup>
    </div>
  </vx-card>
</template>

<script>
import "@/assets/css/main.css";
import SettingsService from "@/services/SettingsService";
import UtilService from "@/services/UtilService";
import UserService from "@/services/UserService";
import TimeZone from "@/services/TimeZone";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    vSelect,
    Datepicker
  },
  data() {
    return {
    userInfo: {},
      Settings: {
        Id: "",
        Name: "",
        Type: "",
        Status: "Active",
        IsDeleted: 0,
        CreatedDate: Date,
        CreatedBy: "",
        ModifiedDate: Date,
        ModifiedBy: ""
      },
      IsAdmin: false,
      industryList: [],
      referenceList: [],
      clientTypeList: [],
      industryPopup: false,
      referencePopup: false,
      clientTypePopup: false,
      industryErrorMessage: '',
      referenceErrorMessage: '',
      clienttypeErrorMessage: '',

      timezoneFilter: {},
      timezoneOptions: TimeZone.getTimeZones(),

      industryFilter: "",
      referenceFilter: "", 
    };
  },
  methods: {
    fetchSettingData(settingsId) {
      SettingsService.getById(settingsId).once("value", item => {
        if (item && item.val()) {
          this.Settings = item.val();
        }
      });
    },
    saveSettings(type,name) {
      this.industryErrorMessage = '';
      this.referenceErrorMessage = '';
      this.clienttypeErrorMessage = '';
      this.Settings["Type"] = type;
      this.Settings['Name'] = name;
        if (name != '') {
          if(type === 'Industry'){
            this.industryPopup = false;
          } else if(type === 'Reference'){
            this.referencePopup = false;
          } else if(type === 'ClientType'){
            this.clientTypePopup = false;
          }
          this.checkIsExists(type, (isExist) => {
            if(isExist){
              UtilService.notifyErrorAlert(
                this.$vs,
                type + " already exists."
              );
            } else {
              if (this.Settings["Id"]) {
                this.Settings["ModifiedBy"] = this.userInfo['Id'];
                SettingsService.update(this.Settings["Id"], this.Settings)
                  .then(() => {
                    this.resetSetting();
                    UtilService.notifySuccessAlert(
                        this.$vs,
                      "Settings updated successfully."
                    );
                    this.fetchSettingData(this.$route.params.settingsId);
                  })
                  .catch(e => {
                      console.log(e);
                  });
              } else {
                this.Settings["CreatedBy"] = this.userInfo['Id'];
                SettingsService.create(this.Settings)
                  .then(obj => {
                    this.resetSetting();
                    if (!obj.val()) {
                      UtilService.notifySuccessAlert(
                        this.$vs,
                        "Settings created successfully."
                      );
                    } else {
                      UtilService.notifyErrorAlert(
                        this.$vs,
                        "Settings already exists."
                      );
                    }
                  })
                  .catch(e => {
                    console.log(e);
                  });
              }
            }
          })

        } else {
          UtilService.notifyErrorAlert(
            this.$vs,
            "Please fill Name field."
          );
          this.industryErrorMessage = 'Industry field is required.';
          this.referenceErrorMessage = 'Reference field is required.';
          this.clienttypeErrorMessage = 'Client Type field is required.';
          this.resetSetting();
        }
    },
    saveTimeZone(){
      this.userInfo.Timezone = this.timezoneFilter;
      UserService.update(this.userInfo.Id,this.userInfo).then(() => {
        UtilService.notifySuccessAlert(
          this.$vs,
          "Time Zone updated successfully. Please Logout and Login again."
        );
      })
    },
    checkIsExists(type, callback){
      let array = [];
      let isExist = false;
      if(type === 'Industry'){
        array = this.industryList;
      } else if(type === 'Reference'){
        array = this.referenceList;
      } else if(type === 'ClientType'){
        array = this.clientTypeList;
      }
      array.forEach((item, i) => {
        if(item && item.toLowerCase().trim() === this.Settings['Name'].toLowerCase().trim()){ 
          isExist = true;
        }
      });
      callback(isExist);
    },
    resetSetting(){
      this.Settings = {
        Id: "",
        Name: " ",
        Type: "",
        Status: "Active",
        IsDeleted: 0,
        CreatedDate: Date,
        CreatedBy: "",
        ModifiedDate: Date,
        ModifiedBy: ""
      }
    },
    setValues(type, name){
      this.industryErrorMessage = '';
      this.referenceErrorMessage = '';
      this.clienttypeErrorMessage = '';
      SettingsService.getByName(name).on("value", items => {
        items.forEach(item => {
          let key = item.key;
          let data = item.val();
          
          if (data["Type"] == type) {
            this.Settings = {
              Id: data["Id"],
              Name: data["Name"],
              Type: data["Type"],
              Status: data["Status"],
              IsDeleted: data["IsDeleted"],
              CreatedDate: data["CreatedDate"],
              CreatedBy: data["CreatedBy"],
              ModifiedDate: Date,
              ModifiedBy: data["ModifiedBy"]
            }
          }
        });
      });
    },
    getSettings() {
      SettingsService.getAll().on("value", items => {
        this.industryList = [];
        this.referenceList = [];
        this.clientTypeList = [];
        items.forEach(item => {
          let key = item.key;
          let data = item.val();
          if (data["Type"] == "Industry") {
            this.industryList.push(data["Name"]);
          } else if (data["Type"] == "Reference") {
            this.referenceList.push(data["Name"]);
          } else if (data["Type"] == "ClientType") {
            this.clientTypeList.push(data["Name"]);
          }
        });
        this.industryList.sort((a, b) => a.localeCompare(b))
        this.referenceList.sort((a, b) => a.localeCompare(b))
      });
    }
  },
  created() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;
    this.getSettings();
    if (this.$route.params.settingsId) {
      this.fetchSettingData(this.$route.params.settingsId);
    }
  
    if(this.userInfo.Role === 'Admin')
    {
      this.IsAdmin = true
    }
    this.timezoneFilter = this.userInfo.Timezone
  }
};
</script>
<style lang="scss">
.mg-30{
  margin-right:30px;
}

.w-200{
  width:1000px;
  margin:0px;
}

.card-px{
  margin-left:28%;
  height:400px;
  width:700px;
}

@media screen and (max-width: 325px) {
  .card-px{
     margin-left:0;
     margin-right:0;
     height:450px;
     width:245px;
  }
  .vs-button{
   overflow: visible;
  }
    .vx-row{
      margin:auto;
      padding-right:85%;
  }
 }

 @media screen and (max-width: 280px) {
  .card-px{
     margin: auto;
    padding: 10px;
     height:510px;
     width:215px;
  }
  .vs-button{
   overflow: visible;
  }
    .vx-row{
      padding-right:100%;
  }
 }

 @media screen and (min-width: 345px) and (max-width: 400px) {
  .card-px{
     margin: auto;
    padding: 10px;
     height:450px;
     width:285px;
  }
  .vs-button{
   overflow: visible;
  }
    .vx-row{
      margin:auto;
      padding-right:70%;
      padding-left:2%;
  }
 }

 @media screen and  (min-width: 400px) and (max-width: 786px) {
  .card-px{
     height:450px;
     width:295px;
      margin: auto;
    padding: 10px;
  }
  .vs-button{
   overflow: visible;
  }

   .vx-row{
      margin:auto;
      padding-right:50%;
  }
 }

 @media screen and (min-width: 768px) and (max-width: 1024px) {
  .card-px{
    margin: auto;
    padding: 10px;
     height:350px;
     width:655px;
  }
  .vs-button{
   overflow: visible;
  }
   .vx-row{
      margin:auto;
      padding-right:12%;
  }
 }

 @media screen and (min-width: 1024px) and (max-width: 1366px) {
  .card-px{
    margin: auto;
    padding: 10px;
     width:918px;
  }
  .vs-button{
   overflow: visible;
  }
   .vx-row{
      margin:auto;
      padding-right:50%;
  }
 }
</style>
